import { z } from 'zod';
import { BaseValidatorSchema } from '../base-validator-schema';

export const FutureDateValidator = z.literal('futureDate');
export type TFutureDateValidator = z.infer<typeof FutureDateValidator>;

export const FutureDateValidatorParamsSchema = z.object({});

export type TFutureDateValidatorParams = z.infer<typeof FutureDateValidatorParamsSchema>;

export const FutureDateValidatorSchema = BaseValidatorSchema.extend({
  type: FutureDateValidator,
  value: FutureDateValidatorParamsSchema.optional(),
});
